import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "20", height: "8", x: "2", y: "14", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6.01 18H6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10.01 18H10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 10v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.84 7.17a4 4 0 0 0-5.66 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20.66 4.34a8 8 0 0 0-11.31 0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Router";
const Router = memo(themed(Icon));
export {
  Router
};
//# sourceMappingURL=router.js.map
